// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GhN0","colMin":"styles_colMin__2zHmb"};